import styled from 'styled-components';
import { colors } from 'constants/theme';
export const Container = styled.div.withConfig({
  displayName: "hashtagscss__Container",
  componentId: "sc-274ffu-0"
})(["display:flex;flex-wrap:wrap;"]);
export const Tag = styled.span.withConfig({
  displayName: "hashtagscss__Tag",
  componentId: "sc-274ffu-1"
})(["margin:", ";padding:5px;border-radius:7px;color:", ";background:", ";font-size:1.4rem;"], ({
  $isSmall
}) => $isSmall ? `2px 5px 2px 0px` : `0.5rem 10px 0.5rem 0px`, colors.darkGrey, colors.lightestGrey);